const convertDateTimetoTime = (t) => {
  if (t == null) return '';
  const s = String(t).trim();

  // Exact HH:mm:ss -> passthrough
  let m = s.match(/^(\d{2}):(\d{2}):(\d{2})$/);
  if (m) return `${m[1]}:${m[2]}:${m[3]}`;

  // Exact HH:mm -> pad seconds
  m = s.match(/^(\d{2}):(\d{2})$/);
  if (m) return `${m[1]}:${m[2]}:00`;

  // ISO or any string containing a time portion ...HH:mm[:ss]...
  m = s.match(/(?:T|\s|^)(\d{2}):(\d{2})(?::(\d{2}))?/);
  if (m) return `${m[1]}:${m[2]}:${m[3] ?? '00'}`;

  return '';
};

export default convertDateTimetoTime;
